<app-displaybar buttonTitle="Book Now" text="The Right Tools. The Right Training. "></app-displaybar>
<ng-container *ngFor="let card of onecards;">
 <app-centercard [card]="card"></app-centercard>
</ng-container>
